import { HeyDriveType } from '@/models/drive.ts'

interface DriveDefaults {
  previewPicture: string
  color_primary: string
  color_neutral: string
  color_content: string
}

export const PORTAL_PRIMARY = 'c0a37c'
export const PORTAL_NEUTRAL = 'FFFFFF'
export const PORTAL_TEXT = '040404'

// Portal gray scale — reusable constants for consistent UI
export const PORTAL_BG = '#F8F7F5'           // Page background, top bar
export const PORTAL_SIDEBAR_BG = '#F5F4F3'   // Sidebar background
export const PORTAL_BORDER = '#E5E2DF'       // Borders, dividers

const driveDefaults: Record<HeyDriveType, DriveDefaults> = {
  [HeyDriveType.WEDDING]: {
    previewPicture: '/demoX/demo-wedding-preview.jpg',
    color_primary: '781140',
    color_neutral: 'f5f1ef',
    color_content: '040404',
  },
  [HeyDriveType.PARTY]: {
    previewPicture: '/demoX/birthday-preview.jpg',
    color_primary: 'f89584',
    color_neutral: 'f8f2ec',
    color_content: '2f2d2d',
  },
  [HeyDriveType.BIRTHDAY]: {
    previewPicture: '/demoX/birthday-preview.jpg',
    color_primary: 'f89584',
    color_neutral: 'f8f2ec',
    color_content: '2f2d2d',
  },
  [HeyDriveType.BABY_SHOWER]: {
    previewPicture: '/baby-shower-preview-picture.jpg',
    color_primary: 'CCC094',
    color_neutral: 'F1F1EF',
    color_content: '403D3D',
  },
  [HeyDriveType.COMPANY]: {
    previewPicture: '/demoX/company-preview.jpeg',
    color_primary: '4A8179',
    color_neutral: 'FCFBF7',
    color_content: '0F0F0F',
  },
  [HeyDriveType.PROF]: {
    previewPicture: '/demoX/demo-wedding-preview.jpg',
    color_primary: PORTAL_PRIMARY,
    color_neutral: PORTAL_NEUTRAL,
    color_content: PORTAL_TEXT,
  },

}

export function getDriveDefaultsFor(driveType: HeyDriveType) {
  return driveDefaults[driveType]
}
